import * as swcHelpers from '@swc/helpers';
import { isEveryLineItemReorderable } from '../../../utils/is-line-item-reorderable.js';
import { toDrafts } from '../../server/to-drafts.js';
import { toOrderLineItem } from '../line-item/order-line-item.js';
import '@grandvisionhq/utils';
import { getPaymentMethodLabel } from '../utils/get-payment-method-label.js';
import { getPaymentStatusLabel } from '../utils/get-payment-status-label.js';
import { isSupportedLineItem } from '../utils/order-line-item-product-type-guards.js';
import '@grandvisionhq/graphql';
import { getShipmentStatusLabel } from '../utils/get-shipment-status-label.js';
import { getOrderStatusLabel } from '../utils/get-order-status-label.js';
import { toAddress, toOrderDetailPrice } from './orders.js';

const toOrderDetails = (order, intl, options = {})=>{
    var ref;
    if (!order) {
        return undefined;
    }
    const allLineItems = order.lineItems.filter(isSupportedLineItem);
    var ref1;
    const allShipments = (ref1 = (ref = order.shippingInfo) === null || ref === void 0 ? void 0 : ref.shipments) !== null && ref1 !== void 0 ? ref1 : [];
    // Map each shipment with its line items for individual shipment display
    const mappedShipments = allShipments.filter((shipment)=>shipment.lineItems && shipment.lineItems.length > 0
    ).map((shipment, index)=>{
        const extendedShipment = shipment;
        var _trackingUrl;
        return {
            id: extendedShipment.id || `shipment-${index}`,
            lineItems: shipment.lineItems.filter(isSupportedLineItem).map(toOrderLineItem.bind(null, intl, options)),
            shippingDate: extendedShipment.shippingDate ? new Date(extendedShipment.shippingDate) : undefined,
            trackingUrl: (_trackingUrl = extendedShipment.trackingUrl) !== null && _trackingUrl !== void 0 ? _trackingUrl : undefined
        };
    });
    // Track quantity of each line item that is in shipments
    const lineItemQuantitiesInShipments = new Map();
    allShipments.forEach((shipment)=>{
        shipment.lineItems.filter(isSupportedLineItem).forEach((item)=>{
            const currentQuantity = lineItemQuantitiesInShipments.get(item.id) || 0;
            lineItemQuantitiesInShipments.set(item.id, currentQuantity + item.quantity);
        });
    });
    // Filter line items and adjust quantities based on what's in shipments
    const lineItemsNotInShipments = allLineItems.map((item)=>{
        const quantityInShipments = lineItemQuantitiesInShipments.get(item.id) || 0;
        const remainingQuantity = item.quantity - quantityInShipments;
        // If all quantity is in shipments, exclude this item
        if (remainingQuantity <= 0) {
            return null;
        }
        // If some quantity is in shipments, return item with adjusted quantity
        if (quantityInShipments > 0) {
            return swcHelpers.objectSpread({}, item, {
                quantity: remainingQuantity
            });
        }
        // No quantity in shipments, return as is
        return item;
    }).filter((item)=>item !== null
    );
    var ref2, _receiptUrl, _shipmentTrackingURL, _paymentStatus;
    return swcHelpers.objectSpread({
        billingAddress: toAddress(order.billingAddress),
        shippingInfo: order.shippingInfo.deliveryMethodName,
        shipments: mappedShipments,
        drafts: toDrafts(allLineItems),
        isReorderAvailable: isEveryLineItemReorderable(allLineItems),
        lineItems: lineItemsNotInShipments.map(toOrderLineItem.bind(null, intl, options)),
        orderDate: new Date(order.orderDate),
        orderNumber: order.orderNumber,
        paymentMethod: getPaymentMethodLabel(order.paymentMethod, intl),
        paymentStatus: (ref2 = getPaymentStatusLabel(order.paymentStatus, intl)) !== null && ref2 !== void 0 ? ref2 : '',
        isOrderReturnable: order.returnStatus === 'RETURNABLE',
        receiptUrl: (_receiptUrl = order.receiptUrl) !== null && _receiptUrl !== void 0 ? _receiptUrl : undefined,
        shipmentStatus: getShipmentStatusLabel(order.shipmentStatus, intl),
        orderStatus: getOrderStatusLabel(order.state, intl),
        shipmentTrackingUrl: (_shipmentTrackingURL = order.shipmentTrackingURL) !== null && _shipmentTrackingURL !== void 0 ? _shipmentTrackingURL : undefined,
        shippingAddress: toAddress(order.shippingAddress),
        rawPaymentStatus: (_paymentStatus = order.paymentStatus) !== null && _paymentStatus !== void 0 ? _paymentStatus : '',
        customerDetails: {
            email: order.customerDetails.email
        }
    }, toOrderDetailPrice(order.price));
};

export { toOrderDetails };
//# sourceMappingURL=order-details.js.map
